import React, { useEffect } from "react";
import { Modal, Form, InputNumber } from "antd";

const EditPriceModal = ({ t, open, title, onClose, onSubmit }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    onSubmit?.(Number(values.price));
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      okText={t("update")}
      cancelText={t("cancel")}
      title={title}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="price"
          label={t("price")}
          rules={[
            {
              required: true,
              message: t("validate_product_price_required"),
            },
            {
              validator: (_, value) => {
                if (value === undefined || value === null || value === "") {
                  return Promise.resolve();
                }

                if (Number(value) <= 0) {
                  return Promise.reject(
                    new Error(t("validate_product_price_required")),
                  );
                }

                return Promise.resolve();
              },
            },
          ]}
        >
          <InputNumber
            min={0.01}
            step={0.01}
            precision={2}
            className="app-w-full"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditPriceModal;
